import styled from 'styled-components';
import Label from '../Label';
import Button from '../Button';
import Box from '../Box';

export const StyledFooter = styled.footer`
  display: block;
  width: 100%;
  padding-bottom: 24px;
  padding-top: 60px;
`;

export const StyledFooterBox = styled(Box)`
  grid-column-gap: 18px;
`;

export const FooterLabel = styled.div`
  display: block;
  border-bottom: 1px solid ${({ theme }) => theme.COLORS.LIGHT_SILVER};
  line-height: ${({ theme }) => theme.FONT_SIZES.LARGE};
  font-size: ${({ theme }) => theme.FONT_SIZES.LARGE};
  font-family: ${({ theme }) => theme.FONT.LIGHT};
  text-align: center;
  margin-bottom: 24px;
  padding-bottom: 12px;
`;

export const StyledLabelMore = styled(Label)`
  margin-top: 24px;
  padding-bottom: 12px;
  text-align: center;
`;

export const StyledFooterButton = styled(Button.Secondary)`
  border: 2px solid ${({ theme }) => theme.COLORS.BASE_INVERTED};

  &:first-child:not(:only-child) {
    margin-left: auto;
  }

  &:not(:first-child):not(:only-child) {
    margin-right: auto;
  }

  &:only-child {
    margin: auto;
  }

  a {
    text-decoration: none;
    color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  }

  &:hover a {
    color: ${({ theme }) => theme.COLORS.DARK_BLUE};
  }
`;
